/** Returns true if `value` is of type [[DateBefore]]. */
export function isDateBeforeType(value) {
    return Boolean(value && typeof value === 'object' && 'before' in value);
}
//# sourceMappingURL=isDateBeforeType.js.map